import React, { Component } from "react";
import { connect } from 'react-redux';
import * as url from '../../../utils/url';
import axios from '../../../axios';
import * as actionCreators from '../../../modules/actions/index';
import MapDisability from '../../../components/OrganizationSetup/MapDisability/MapDisability';
import EnterpriseBreadcrumb from '../../../components/EnterpriseBreadcrumb/EnterpriseBreadcrumb';

class MapDisabilityManagement extends Component {
  // constructor(props) {
  //   super(props);
  // }

  componentDidMount() {
    window.scrollTo(0, 0);
    const {organizationId} = this.props.user;

    axios.get(url.getExistingMappings(organizationId._id)).then(({data}) => {
      const payload = data.data;
      console.log(payload)
      const {disability} = payload.mapping;
      if(disability.columnName) {
        this.props.onMatchColumn(disability.columnName);
      }
      const disabilityData = disability.data;
      let allMapping = []
      disabilityData.forEach((c) => {
        const mapping = c.values.map((v) => {
          return {
            value : v,
            column : {
              label : c.reference.name,
              value : c.reference._id
            }
          }
        })
        allMapping = allMapping.concat(mapping);
      })
      this.props.saveAllDisabilityMapping(allMapping);
    })
  }

  componentWillUnmount() {
    this.props.resetMapDisabilityStep();
  }

  handleFileUpload = (columns, data, file) => {
    console.log(columns, data, file)
    this.props.onFileDataProcessed(columns, data, file);
  }

  handleMatchColumn = (matchedColumn) => {
    this.props.onMatchColumn(matchedColumn);
  }

  handleSkipMapping = () => {
    // console.log('Skip performance mapping');
  }

  render() {
    console.log(this.props)
    return (
      <div className="mt60 enterprise-map-page">
      <EnterpriseBreadcrumb 
        linkText="Enterprise Management" 
        link="/home/enterprise-info" 
        activeText="Map Disability"
        {...this.props}
        />
      <MapDisability 
        onProcessedFileUploadData={this.handleFileUpload}
        onSkipDisabilityMapping={this.handleSkipMapping}
        isRepeatFlow={true}
        {...this.props}/>
      </div>
    );
  }
}

const mapStateToProps = state => {
  console.log(state)
  return {
    user: state.user.profile,
    mapDisability : state.mapping.disability
  }
}

const mapDispatchToProps = dispatch => {
	return {
    resetMapDisabilityStep: () => dispatch(actionCreators.resetMapDisabilityStep()),
    nextStep: () => dispatch(actionCreators.mapDisabilityNextStep()),
    goBack : () => dispatch(actionCreators.mapDisabilityGoBack()),
    reset : () => dispatch(actionCreators.resetDisability()),
    saveAllDisabilityMapping : (o,s) => dispatch(actionCreators.saveAllDisabilityMapping(o,s)),
    onFileDataProcessed: (c,d,f) => dispatch(actionCreators.mapDisabilityUploadFileSuccess(c,d,f)),
    onMatchColumn: data => dispatch(actionCreators.mapDisabilityMatchColumnSuccess(data))
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(MapDisabilityManagement);